module.exports = __webpack_public_path__ + "dacb9d331921eca55eb6944ace56eaca.pdf";